import React from "react";
import backeb from "./assets/img/backeb.gif";
import logotop from "./assets/img/logotop.gif";
import "./LandingPage.css";
import { useNavigate } from 'react-router-dom';
const API_BASE = process.env.REACT_APP_API_URL;


function LandingPage() {
    const navigate = useNavigate();

const handleSubmit = async (e) => {
    e.preventDefault();
    const inst_code = e.target.inst_code.value;
    const password = e.target.password.value;

    try {
        const response = await fetch(`${API_BASE}/api/login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ inst_code, password }),
        });

        const payload = await response.json();

        if (response.ok && payload.success) {
            console.log("Login successful:", payload.data);
            
            // Extract the PASSWORD and other sensitive data if needed
            const { PASSWORD, ...instituteDataWithoutPassword } = payload.data;
            
            // Store authentication data only (role and admin status)
            localStorage.setItem("auth", JSON.stringify({
                role: payload.data.role,
                isAdmin: payload.data.isAdmin,
                loggedInInstCode: payload.data.INST_ID
            }));
            
            // Store complete institute data (all columns except password)
            localStorage.setItem("instituteData", JSON.stringify(instituteDataWithoutPassword));
            
            // For backward compatibility with existing code
            localStorage.setItem("currentView", JSON.stringify(instituteDataWithoutPassword));
            
            console.log("Auth stored:", {
                role: payload.data.role,
                isAdmin: payload.data.isAdmin,
                loggedInInstCode: payload.data.INST_ID
            });
            
            console.log("Institute data stored:", instituteDataWithoutPassword);
            
            // Redirect based on role
            if (payload.data.role === "admin") {
                navigate("/ViewSentApplication");
            } else {
                navigate("/simApp");
            }
        } else {
            alert(payload.message || "Login failed");
        }
    } catch (error) {
        alert("Server not responding. Try again later.");
        console.error(error);
    }
};
    return (
        <div style={{ backgroundImage: `url(${backeb})`, backgroundSize: "cover" }}>
            <div id="container">
                <div id="shape1" style={{
                    border: "1px solid #c0c0c0", overflow: "hidden", position: "absolute",
                    left: 4, top: 35, width: 733, height: 457, zIndex: 0, backgroundColor: "#fff"
                }} />

                <div id="image1" style={{
                    overflow: "hidden", position: "absolute", left: 7, top: 39,
                    width: 725, height: 100, zIndex: 1
                }}>
                    <img src={logotop} alt="Logo" height="100" width="725" />
                </div>

                <div style={{
                    overflow: "hidden", position: "absolute", left: 146, top: 41,
                    width: 446, height: 28, zIndex: 3, backgroundColor: "rgb(0, 117, 0)"
                }} />

                <div style={{
                    overflow: "hidden", position: "absolute", left: 146, top: 68,
                    width: 446, height: 66, zIndex: 4, backgroundColor: "rgb(0, 155, 0)"
                }} />

                <div id="text1" style={{
                    position: "absolute", left: 154, top: 46, width: 430,
                    height: 83, zIndex: 6
                }}>
                    <div className="wpmd">
                        <div className="centered-content">
                            <span className="ws12" style={{ color: "#ccffcc", fontWeight: "bold" }}>
                                Ministry of Education, Government of Bangladesh
                            </span>
                        </div>
                        <div className="centered-content2">
                            <span className="ws12" style={{ color: "#ffffff", fontWeight: "bold" }}>
                                Bangladesh Technical Education Board
                            </span>
                        </div>
                    </div>
                </div>

                <div style={{
                    overflow: "hidden", position: "absolute", left: 9, top: 156,
                    width: 720, height: 1, zIndex: 7, backgroundColor: "#c0c0c0"
                }} />

                <div id="main" style={{
                    overflow: "hidden", position: "absolute", left: 7, top: 160,
                    width: 727, height: 300, zIndex: 9, backgroundColor: "#fff",
                    display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                    <div className="login-container">
                        <h3>EIIN SIM Login Panel (Institute)</h3>
                        <form method="POST" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Institute Code</label>
                                <div className="input-container">
                                    <input type="text" name="inst_code" placeholder="Institute Code" required />
                                </div>
                            </div>

                            <div className="form-group" >
                                <label>Password</label>
                                <div className="input-container">
                                    <input type="password" name="password" placeholder="Password" required />
                                </div>
                            </div>

                            <div className="form-actions">
                                <button type="button" className="btn btn-primary" onClick={() =>window.open("http://180.211.162.102:5000/uploads/eiin_sim_manual.pdf", "_blank")}>Manual</button>
                                <button type="submit" className="btn btn-info">Sign in</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div id="shape5" style={{
                    overflow: "hidden", position: "absolute", left: 7, top: 432,
                    width: 727, height: 57, backgroundColor: "#ddd"
                }} />

                <div id="shape6" style={{
                    overflow: "hidden", position: "absolute", left: 7, top: 453,
                    width: 727, height: 4, zIndex: 11, backgroundColor: "rgb(0, 128, 0)"
                }} />
            </div>
        </div>
    );
}

export default LandingPage;
